/*
 *
 * OperationSecurityWarnings
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 01-Jul-2024
 */

import { connect } from 'react-redux'
import OperationSecurityWarnings from './OperationSecurityWarnings'

const mapDispatchToProps = {}

const mapStateToProps = (state) => ({
  warnings: state.operations?.operation?.warnings || [],
  isLoading: state.loading.local_OperationDetails || false
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(OperationSecurityWarnings)
